import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class TableService {
    private mouseoverSubject = new Subject<any>()

    mouseover$ = this.mouseoverSubject.asObservable()

    setupHover(columnIndex: number) {
        this.mouseoverSubject.next(columnIndex)
    }
}
